import $axios from "../../api";

const PREFIX = "website/smart-promo";

const state = {
  isLoading: false,
  createLoading: false,
  errors: null,
  isSuccess: false,
  list: [],
  page: 1,
  detail: null,
  setting: { title: null, subtitle: null },
  totalLive: 0,
};

const mutations = {
  SET_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SUCCESS(state, payload) {
    state.isSuccess = payload;
  },
  SET_LIST(state, payload) {
    state.list = payload;
  },
  SET_PAGE(state, payload) {
    state.page = payload;
  },
  SET_CREATE_LOAD(state, payload) {
    state.createLoading = payload;
  },
  SET_DETAIL(state, payload) {
    state.detail = payload;
  },
  CLEAR_DETAIL(state) {
    state.detail = null;
  },
  SET_SETTING(state, payload) {
    state.setting = payload;
  },
  SET_TOTAL_LIVE(state, payload) {
    state.totalLive = payload;
  },
};

const actions = {
  getSetting({ commit, dispatch }) {
    return $axios
      .get(`${PREFIX}/list-setting`)
      .then((res) => commit("SET_SETTING", res.data.data))
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },

  updateSetting({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    return $axios
      .put(`${PREFIX}/create-setting`, payload)
      .then((res) => {
        commit("SET_SUCCESS", true);
        if (res.data?.data) {
          commit("SET_SETTING", res.data.data);
        }
        dispatch(
          "Main/globalSuccessSweetAlert",
          res.data?.message || "Setting berhasil diperbarui.",
          { root: true }
        );
      })
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },

  getList({ commit, state, rootState, dispatch }, payload) {
    commit("SET_LOADING", true);
    return $axios
      .get(
        `${PREFIX}/list?page=${state.page}&view=${rootState.Main.view}${payload || ""}`
      )
      .then((res) => {
        commit("SET_LIST", res.data.data);
      })
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      )
      .finally(() => commit("SET_LOADING", false));
  },

  getDetail({ commit, dispatch }, id) {
    commit("SET_LOADING", true);
    commit("CLEAR_DETAIL");
    return $axios
      .get(`${PREFIX}/view/${id}`)
      .then((res) => commit("SET_DETAIL", res.data.data))
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      )
      .finally(() => commit("SET_LOADING", false));
  },

  createData({ commit, dispatch }, payload) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);
    commit("SET_ERRORS", null);
    return $axios
      .post(`${PREFIX}/create`, payload)
      .then(() => commit("SET_SUCCESS", true))
      .catch((err) => {
        commit("SET_ERRORS", err.response?.data?.errors || null);
        dispatch("Main/globalSweetAlert", err.response, { root: true });
      })
      .finally(() => commit("SET_CREATE_LOAD", false));
  },

  updateData({ commit, dispatch }, { id, payload }) {
    commit("SET_SUCCESS", false);
    commit("SET_CREATE_LOAD", true);
    commit("SET_ERRORS", null);
    return $axios
      .put(`${PREFIX}/update/${id}`, payload)
      .then(() => commit("SET_SUCCESS", true))
      .catch((err) => {
        commit("SET_ERRORS", err.response?.data?.errors || null);
        dispatch("Main/globalSweetAlert", err.response, { root: true });
      })
      .finally(() => commit("SET_CREATE_LOAD", false));
  },

  showHide({ commit, dispatch }, id) {
    commit("SET_SUCCESS", false);
    return $axios
      .put(`${PREFIX}/showhide/${id}`)
      .then((res) => {
        commit("SET_SUCCESS", true);
        dispatch("Main/globalSuccessSweetAlert", res.data.message, {
          root: true,
        });
      })
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },

  changePosition({ commit, dispatch }, { id, sequence }) {
    commit("SET_SUCCESS", false);
    return $axios
      .put(`${PREFIX}/change-position/${id}`, { sequence })
      .then(() => commit("SET_SUCCESS", true))
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },

  fetchTotalLive({ commit, dispatch }) {
    return $axios
      .get(`${PREFIX}/products-total`)
      .then((res) => commit("SET_TOTAL_LIVE", res.data?.data?.total || 0))
      .catch((err) =>
        dispatch("Main/globalSweetAlert", err.response, { root: true })
      );
  },

  fetchProducts({ dispatch }, queryString) {
    return $axios
      .get(`${PREFIX}/products?${queryString || ""}`)
      .then((res) => res.data.data)
      .catch((err) => {
        dispatch("Main/globalSweetAlert", err.response, { root: true });
        return null;
      });
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
